"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AutocompleteAddressType;
(function (AutocompleteAddressType) {
    AutocompleteAddressType["City"] = "c";
    AutocompleteAddressType["Street"] = "s";
    AutocompleteAddressType["Object"] = "o";
    AutocompleteAddressType["House"] = "h";
})(AutocompleteAddressType = exports.AutocompleteAddressType || (exports.AutocompleteAddressType = {}));
//# sourceMappingURL=types.js.map